import React from 'react'
import { ConfirmCriminalRecordCheck } from './ConfirmCriminalRecordCheck'

// TODO : refactor the renewal flow for crimial record check. 
// 
export const MraRenewalBrokerCriminalRecordCheck = (props) => {
    return (
        <ConfirmCriminalRecordCheck {...props} forBrokerApplication />
    )
}
